// Faza 2 sledzenia pozycji: chromagram z widma FFT. Czysta matematyka, bez
// zadnego API przegladarki - `AnalyserNode` produkuje `Uint8Array`, ktory
// wchodzi tu jako zwykle dane, dzieki czemu ten modul testuje sie bez DOM.

/** 12 klas wysokosci, C=0, C#=1, ..., B=11. Wartosci 0..1. */
export type Chroma = Float32Array;

/** Najnizsza czestotliwosc referencyjna (C0), podstawa mapowania na klasy. */
const C0_HZ = 16.35;

/** Pomijamy szum ponizej tej czestotliwosci. */
const MIN_HZ = 60;

/** Pomijamy harmoniczne gitary powyzej tej czestotliwosci. */
const MAX_HZ = 2000;

/**
 * Mapuje dane FFT (`getByteFrequencyData`) na 12-elementowy wektor chromy.
 * Kazdy bin `i` odpowiada czestotliwosci `i * sampleRate / fftSize`. Biny
 * spoza `[MIN_HZ, MAX_HZ]` sa pomijane. Amplitudy binow nalezacych do tej
 * samej klasy wysokosci sa sumowane, a wynik jest normalizowany do max = 1.
 */
export function computeChroma(fftData: Uint8Array, sampleRate: number, fftSize: number): Chroma {
  const chroma = new Float32Array(12);

  for (let i = 0; i < fftData.length; i++) {
    const freq = (i * sampleRate) / fftSize;
    if (freq < MIN_HZ || freq > MAX_HZ) continue;

    const amplitude = fftData[i];
    if (amplitude === undefined || amplitude === 0) continue;

    const pitchClass = (((Math.round(12 * Math.log2(freq / C0_HZ))) % 12) + 12) % 12;
    chroma[pitchClass] = (chroma[pitchClass] ?? 0) + amplitude;
  }

  let max = 0;
  for (let i = 0; i < 12; i++) {
    const v = chroma[i] ?? 0;
    if (v > max) max = v;
  }
  if (max > 0) {
    for (let i = 0; i < 12; i++) chroma[i] = (chroma[i] ?? 0) / max;
  }

  return chroma;
}
